




















































































import sortBy from 'lodash/sortBy'
import { mapActions, mapGetters } from 'vuex'
function sort(arrayOfTeamMembers) {
  return sortBy(arrayOfTeamMembers, 'fullName')
}
export default {
  props: {
    show: { type: Boolean, required: true }
  },
  data() {
    return {
      selectedTeamMembers: [],
      teamMemberOptions: [],
      invitationsSent: false,
      loading: false
    }
  },
  computed: {
    ...mapGetters(['teamMembers']),
    unselectedTeamMembers() {
      return this.teamMembers.filter(teamMember => !this.isSelected(teamMember))
    },
    selectedValuesText() {
      return sort(this.selectedTeamMembers)
        .map(({ fullName }) => fullName)
        .join(', ')
    }
  },
  watch: {
    teamMembers() {
      this.buildOptions()
    }
  },
  methods: {
    ...mapActions(['fetchTeamMembers', 'inviteTeamMembers']),
    buildOptions() {
      this.teamMemberOptions = sort(this.selectedTeamMembers).concat(
        sort(this.unselectedTeamMembers)
      )
    },
    isSelected(teamMember) {
      return this.selectedTeamMembers.includes(teamMember)
    },
    onCloseMultiSelect() {
      this.buildOptions()
    },
    onClickInviteMore() {
      this.selectedTeamMembers = []
      this.invitationsSent = false
      this.buildOptions()
    },
    async handleShown() {
      await this.fetchTeamMembers()
    },
    async handleConfirmInvite() {
      if (!this.selectedTeamMembers.length) return
      await this.inviteTeamMembers(this.selectedTeamMembers.map(({ id }) => id))
      this.invitationsSent = true
    }
  }
}
